import mutations from './mutations'
import actions from './actions'

const state = {
  facility_extra_pricing: [],
  deleted_facility_extra_pricing: [],
  facility_commission:[]
}

export default {
  state, mutations, actions
}
